import { ContainerModule } from '@yandex-int/k-common/typings';
import { Link } from 'platform-components';
import { SimpleCallback } from 'platform-components/common';
import React from 'react';

import { CourseContainerArrowButton } from '../__arrow-button/course-container__arrow-button';
import { CourseContainerModuleCardPreview } from '../__module-card-preview/course-container__module-card-preview';
import { CourseContainerModuleCard } from '../__module-card/course-container__module-card';

import './course-container__module-card-carousel.scss';

interface Props {
    containerModule: ContainerModule;
    nextModule?: ContainerModule;
    onNextCardClick?: SimpleCallback;
    nextModuleLink?: React.ComponentProps<typeof Link>['to'];
    prevModule?: ContainerModule;
    onPrevCardClick?: SimpleCallback;
    prevModuleLink?: React.ComponentProps<typeof Link>['to'];
    openModuleOrder?: number;
    openModuleOrderFromActiveGroup?: number;
}

export const CourseContainerModuleCardCarousel = ({
    containerModule,
    nextModule,
    onNextCardClick,
    nextModuleLink,
    prevModule,
    onPrevCardClick,
    prevModuleLink,
    openModuleOrder = 0,
    openModuleOrderFromActiveGroup = 0,
}: Props) => {
    return (
        <div className="course-container__module-card-carousel">
            <div className="course-container__module-card-carousel-content">
                <CourseContainerModuleCard
                    containerModule={containerModule}
                    openModuleOrder={openModuleOrder}
                    openModuleOrderFromActiveGroup={openModuleOrderFromActiveGroup}
                />

                {nextModule && (
                    <CourseContainerArrowButton
                        className="course-container__arrow-button_right"
                        direction={CourseContainerArrowButton.DIRECTION.RIGHT}
                        link={nextModuleLink}
                        onClick={onNextCardClick}
                    />
                )}

                {prevModule && (
                    <CourseContainerArrowButton
                        className="course-container__arrow-button_left"
                        direction={CourseContainerArrowButton.DIRECTION.LEFT}
                        link={prevModuleLink}
                        onClick={onPrevCardClick}
                    />
                )}

                {nextModule && (
                    <CourseContainerModuleCardPreview
                        className="course-container__module-card-preview_next"
                        containerModule={nextModule}
                        link={nextModuleLink}
                        onClick={onNextCardClick}
                    />
                )}

                {prevModule && (
                    <CourseContainerModuleCardPreview
                        className="course-container__module-card-preview_prev"
                        containerModule={prevModule}
                        link={prevModuleLink}
                        onClick={onPrevCardClick}
                    />
                )}
            </div>
        </div>
    );
};
